// @ts-ignore
import 'setimmediate'

export { GraphqlException, LutherException } from './resolvers/util'
export * from './utils/helpers'
export * from './generated/client/hooks'
export * from './utils/clients'
export * from './utils/schemaMapping/client'
export * from './utils/schemaMapping/mapFeeTypeToCanBeAddedToLoan'
export * from './utils/schemaMapping/mapFeeTypeToFeeTiming'
export * from './utils/currentMortgageProductFeeTypes'
export * from './utils/inactiveCaseStatuses'
export * from './utils/versionedCaseChildEntities'
export * from './utils/formatNumber'
export * from './utils/countries/countries'
export * from './utils/addPeriodFixedEndDate'
export * from './utils/caseVerificationInvalidation'
export { enrichHttpSpansWithMicroserviceTags } from './utils/sentryHttpSpanEnrichment'
export { default as inPlaceReplaceWithArray } from './utils/inPlaceReplaceWithArray/inPlaceReplaceWithArray'
export * from './utils/types'
export * from './resolvers/util'

// TODO: Stop using API methods outside of graphql
export { downloadReport, generateReport } from './api/reports'
export { fetchProtectedClientFields } from './api/client'
export { CaseLoader, clearCaseFromCache, getCaseSurvey } from './api/case'
export { clearSummaryCache } from './api/summary'
export { clearClientUserFromCache } from './api_client_portal/client_user'
export { productApply, productApplyV2 } from './api_protection/methods'
export { getFileForDownload } from './api/reports'

import cpRequest from './requesters/clientPortal'
import cpPropertyDataRequest from './requesters/clientPortalPropertyData'
import chRequest from './requesters/companiesHouse'
import request from './requesters/default'
import giRequest from './requesters/generalInsurance'
import oathKeeper from './requesters/oathKeeper'
import oathKeeperPub from './requesters/oathKeeperPub'
import oryLogin from './requesters/oryLogin'
import prRequest from './requesters/protection'
import prRequestV2 from './requesters/protectionV2'
import searchRequest from './requesters/search'

export const requesters = {
  clientPortal: cpRequest,
  clientPortalPropertyData: cpPropertyDataRequest,
  companiesHouse: chRequest,
  default: request,
  generalInsurance: giRequest,
  protection: prRequest,
  protectionV2: prRequestV2,
  oryLogin: oryLogin,
  oathKeeper: oathKeeper,
  oathKeeperPub: oathKeeperPub,
  searchRequest: searchRequest,
}
